import { render, staticRenderFns } from "./TextInputV1.vue?vue&type=template&id=a067c40c&scoped=true&"
import script from "./TextInputV1.vue?vue&type=script&lang=js&"
export * from "./TextInputV1.vue?vue&type=script&lang=js&"
import style0 from "./TextInputV1.vue?vue&type=style&index=0&id=a067c40c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Kiosk.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a067c40c",
  null
  
)

export default component.exports